import React from 'react';

const NotFound = () => <div>Opa! Não tem nada aqui!</div>

export default NotFound;